import { IEnum, IEnumValue } from '@/pages/MDM/mdm.types.ts'
import SidePage from '@/shared/SidePage'
import SeparateLine from '@/shared/Forms/SeparateLine'
import useStateWithChange from '@/shared/hooks/useStateWithChange.ts'
import FormField from '@/shared/Forms/FormField'
import TextInput from '@/shared/Inputs/TextInput'
import CreateEntityButton from '@/shared/Buttons/CreateEntityButton'
import TrashButton from '@/shared/Buttons/TrashButton'
import useNestedArrayChangeCallbacks from '@/shared/hooks/useNestedArrayChangeCallbacks.ts'
import mdmUtils from '@/pages/MDM/mdm.utils.ts'
import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import Button from '@/shared/Buttons/Button'
import mdmApi from '@/pages/MDM/mdm.api.ts'
import mdmEvents from '@/pages/MDM/events/mdm.events.ts'

interface IProps {
  primitive: IEnum
  open: boolean
  onClose: () => void
  onCloseAnimationEnd?: () => void
}

const EditPrimitiveSidePage = (props: IProps) => {
  const { wait, loading } = useHttpLoader()
  const [primitive, setPrimitive, handleChange] = useStateWithChange(props.primitive)

  const {
    handleCreateNewElement: handleValueCreate,
    handleElementUpdate: handleValueUpdate,
    handleElementDelete: handleValueDelete,
  } = useNestedArrayChangeCallbacks({
    sourceObjectSetter: setPrimitive,
    nestedArrayKey: 'values',
    newEntityGenerator: mdmUtils.generatePrimitiveValue,
  })

  const handleSave = () => {
    wait(mdmApi.updateEnum(primitive, props.primitive.id), (resp) => {
      if (resp.status === 'success') {
        mdmEvents.enumUpdated(resp.body)
        props.onClose()
      }
    })
  }

  const renderValue = (value: IEnumValue, index: number) => {
    return (
      <div className="inline-flex-gap gap8 center" key={index}>
        <TextInput
          value={value.name}
          name="name"
          onChange={(val, name) => handleValueUpdate(index, val, name)}
          placeHolder="Введите значение"
        />
        <TrashButton onClick={() => handleValueDelete(index)} />
      </div>
    )
  }

  return (
    <SidePage onClose={props.onClose} open={props.open} onCloseAnimationEnd={props.onCloseAnimationEnd}>
      <div className="flex-lines gap16 height100">
        <h4 className="text-heading-4">Редактирование примитива</h4>
        <SeparateLine />
        <FormField label="Наименование" required={true}>
          <TextInput value={primitive.name} name="name" onChange={handleChange} placeHolder="Введите наименование" />
        </FormField>
        <SeparateLine />
        <h5 className="text-heading-5">Значения</h5>
        {primitive.values.map(renderValue)}
        <CreateEntityButton onClick={handleValueCreate} text="Добавить значение" type="default" fullWidth={true} />

        <div style={{ marginTop: 'auto' }}>
          <SeparateLine />
        </div>
        <div className="inline-flex-gap gap8">
          <Button
            size="default"
            type="primary"
            disabled={!primitive.name}
            loading={loading}
            onClick={handleSave}
            text="Сохранить"
          />
          <Button size="default" type="default" onClick={props.onClose} disabled={loading} text="Отмена" />
        </div>
      </div>
    </SidePage>
  )
}

export default (props: IProps) => {
  if (!props.primitive) return null

  return <EditPrimitiveSidePage {...props} />
}
